<div class="card filemanager-sidebar me-md-2">
    <div class="card-body">
        <div class="d-flex flex-column h-100">
            <div class="mb-4">
                <ul class="list-unstyled categories-list" *ngFor="let item of menuItems">
                    <li>
                        <div class="custom-accordion">
                            <a class="text-body fw-medium py-1 d-flex align-items-center" (click)="collapse.toggle()"
                                [attr.aria-expanded]="!isCollapsed" data-toggle="collapse" href="javascript:void(0);"
                                role="button" aria-expanded="false" aria-controls="categories-collapse">
                                <i class="mdi mdi-folder font-size-16 text-warning me-2"></i> {{ item.label }}
                                <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                            </a>
                            <div class="collapse show" id="categories-collapse" #collapse="ngbCollapse"
                                [(ngbCollapse)]="isCollapsed">
                                <div class="card border-0 shadow-none ps-2 mb-0">
                                    <ul class="list-unstyled mb-0">
                                        <li *ngFor="let subitem of item.subItems">
                                            <button class="btn btn-secondary btn-rounded" (click)="AbrirNuevoTab()">{{ subitem.label }}</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</div>
